import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import DrawerCard from './DrawerCard';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

DrawerList.propTypes = {
    products: PropTypes.array.isRequired,
};

export default function DrawerList({
    idPermission,
    idCabinet,
    getData,
    products,
    functDelete,
    setData,
    functEdit,
    data,
    screenPermissions,
    ...other
}) {
    const navigate = useNavigate();
    return (
        <Grid container spacing={3} {...other}>
            {products.map((product) => (
                <Grid key={product.id} item xs={12} sm={6} md={6}>
                    <DrawerCard
                        navigate={() =>
                            product.block_status === '1'
                                ? navigate(
                                      `/home/manager-cabinet/${idPermission}/drawer/${product.cabinet_id}/cell/${product.id}`
                                  )
                                : false
                        }
                        getData={getData}
                        functDelete={functDelete}
                        functEdit={functEdit}
                        idPermission={idPermission}
                        data={data}
                        product={product}
                        setData={setData}
                        screenPermissions={screenPermissions}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
